import axios from 'axios';

const API = axios.create({ baseURL: 'https://youtube-analytics-backend-production.up.railway.app' });

export const getCategories = () => API.get('/api/categories').then(r => r.data);
export const getChannels = (id) => API.get(`/api/categories/${id}/channels`).then(r => r.data);
export const getTrends = (id) => API.get(`/api/categories/${id}/trends`).then(r => r.data);
export const getCompetitors = (id) => API.get(`/api/categories/${id}/competitors`).then(r => r.data);
export const getRealTrend          = (id) => API.get(`/api/categories/${id}/real-trend`).then(r => r.data).catch(() => ({ dataPoints: 0, isRealData: false, history: [] }));
export const getCategoryComparison = (id) => API.get(`/api/categories/${id}/comparison`).then(r => r.data);
export const analyzeChannel = (input) => API.post('/api/analyze-channel', { input });
